import { Icon } from '@iconify/react/dist/iconify.js';
import { ButtonBase } from '@mui/material';
import * as React from 'react';


export default function CustomIconButton({ iconName, onClick, color, backgroundColor, borderStyle, marginLeft, marginRight, height, borderRadius, paddingInline, paddingBlock }) {

    return (
        <>
            <ButtonBase
                style={{
                    paddingBlock: paddingBlock || 3,
                    paddingInline: paddingInline || 7,
                    borderRadius: borderRadius || 5,
                    marginLeft: marginLeft || 5,
                    backgroundColor: "transparent",
                    color: color || '#101010',
                }}
                onClick={()=> onClick()}
            >
                <Icon icon={iconName} height={18} width={18}></Icon>
            </ButtonBase>
        </>
    );
}
